<template>
  <div class="row">
    <ul class="progressbar text-center">
      <progress-step
        :stepNumber="createdStep"
        :historyStatus="historyStatus"
        description="Złożenie zamówienia"
        icon="fas fa-shopping-cart"
        type="history"
      ></progress-step>
      <progress-step
        v-if="
          order &&
          (order.PL.includes('DPD') || order.PL.includes('POCZTA')) &&
          order.deleted_at === null
        "
        :stepNumber="inProgressStep"
        :historyStatus="historyStatus"
        description="Zamówienie w trakcie realizacji"
        icon="fas fa-box-open"
        type="history"
      ></progress-step>
      <progress-step
        v-if="order && order.deleted_at === null"
        :stepNumber="completedStep"
        :historyStatus="historyStatus"
        description="Zamówienie zrealizowane"
        icon="fas fa-shipping-fast"
        type="history"
      ></progress-step>
      <progress-step
        v-if="order && order.deleted_at"
        :stepNumber="deletedStep"
        :historyStatus="historyStatus"
        description="Zamówienie anulowane"
        icon="far fa-window-close"
        type="history"
      ></progress-step>
    </ul>
  </div>
</template>

<script>
import ProgressStep from './order/ProgressStep';

export default {
  name: 'HistoryProgressSteps',
  components: { ProgressStep },
  props: {
    order: {},
  },
  computed: {
    createdStep() {
      return 1;
    },
    inProgressStep() {
      return 2;
    },
    completedStep() {
      return this.order.PL.includes('DPD') || this.order.PL.includes('POCZTA')
        ? 3
        : 2;
    },
    deletedStep() {
      return 2;
    },

    historyStatus() {
      if (this.order.deleted_at) {
        return 2;
      }

      if (this.order.NETTO === 0) {
        return 2;
      }

      if (this.order.PL.includes('POBRANIE')) {
        if (this.order.ZAPLACONO !== null && this.order.ZAPLACONO !== '') {
          return 3;
        } else if (this.order.resolved === 1) {
          return 2;
        }
      }

      if (this.order.PL.includes('DPD') || this.order.PL.includes('POCZTA')) {
        if (this.order.resolved === 1) {
          return 3;
        } else if (
          this.order.ZAPLACONO !== null &&
          this.order.ZAPLACONO !== ''
        ) {
          return 2;
        }
      }

      return this.order.ZAPLACONO !== null && this.order.ZAPLACONO !== ''
        ? 2
        : 1;
    },
  },
};
</script>

<style scoped></style>
